<form class="card d-flex">
  <div class="card-content content d-flex align-center">
    <div class="content-group group flex-2 d-flex">
      <span class="group-data data">
        <strong>{{ commission?.Code }}</strong></span
      >
    </div>

    <div class="content-group group flex-3">
      <span class="group-data data">{{ commission?.Company }}</span>
    </div>

    <div class="content-group group flex-3">
      <span class="group-data data">{{ commission?.Bank }}</span>
    </div>

    <div class="content-group group flex-2">
      <span class="group-data data">{{ commission?.Period }}</span>
    </div>

    <div class="content-group group flex-8 d-flex">
      <div
        class="flex-1 d-flex direction-column align-flex-start justify-center products-summary"
      >
        <span *ngFor="let item of productsInfo" class="group-data data"
          >{{ item["name"] + "-" }}<strong>{{ item["value"] }}</strong></span
        >
      </div>
    </div>

    <div class="content-btn d-flex justify-flex-end flex-2">
      <div class="mr-5">
        <button
          type="button"
          class="card-btn d-flex align-center justify-center"
          (click)="openDialogCommission(Action.View)"
        >
          <app-svg-icon
            src="assets/icons/view-icon.svg"
            width="12px"
            height="12px"
            color="white"
          ></app-svg-icon>
        </button>
      </div>

      <div class="mr-5">
        <button
          type="button"
          class="card-btn d-flex align-center justify-center"
          (click)="openDialogCommission(Action.Edit)"
        >
          <app-svg-icon
            src="assets/icons/edit-icon.svg"
            width="12px"
            height="12px"
            color="white"
          ></app-svg-icon>
        </button>
      </div>

      <button
        type="button"
        class="card-btn d-flex align-center justify-center"
        (click)="handlerDeleteCommission()"
      >
        <app-svg-icon
          src="assets/icons/trash-red.svg"
          width="12px"
          height="12px"
          color="white"
        ></app-svg-icon>
      </button>
    </div>
  </div>
</form>
